import { createSelector } from 'reselect';

import getShop from '@core/reducers/shop/selectors/getShop';
import getHasFetchedShop from '@core/reducers/shop/selectors/getHasFetchedShop';

import { SHOP_SCHEDULE_DAYS } from '@shopDetails/constants';

const getSchedules = createSelector(
  getShop,
  getHasFetchedShop,
  (shop, hasFetchedShop) => {
    if (!hasFetchedShop || !shop?.schedules) return null;

    return Object.entries(SHOP_SCHEDULE_DAYS).map(([dayNumber, dayName]) => {
      const schedules = shop.schedules.filter(x => x.day === Number(dayNumber));
      if (schedules.length === 0)
        return {
          index: dayNumber,
          name: dayName,
          shifts: [],
          turn: '',
        };

      return {
        index: dayNumber,
        name: dayName,
        shifts: schedules.map(({ id, to, from }) => ({ id, to, from })),
        turn: schedules[0].turn,
      };
    });
  },
);

export default getSchedules;
